"use client";
import { useMantineColorScheme } from "./use-mantine-color-scheme.mjs";
import { useColorScheme } from "@mantine/hooks";
//#region packages/@mantine/core/src/core/MantineProvider/use-mantine-color-scheme/use-computed-color-scheme.ts
function useComputedColorScheme(defaultValue, options = { getInitialValueInEffect: true }) {
	const osColorScheme = useColorScheme(defaultValue, options);
	const { colorScheme } = useMantineColorScheme();
	return colorScheme === "auto" ? osColorScheme : colorScheme;
}
//#endregion
export { useComputedColorScheme };

//# sourceMappingURL=use-computed-color-scheme.mjs.map